import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  primaryCategories: [],
  secondaryCategories: [],
  thirdLevelCategories: [],
  isOpened: null,
  selectedPrimaryCategory: undefined,
  selectedSecondaryCategory: undefined,
  selectedThirdLevelCategory: undefined,
  suggestedCategoriesBySrId: {},
};

export const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    removePrimaryCategory: (state, action) => {
      if (
        state.primaryCategories?.findIndex(
          (category) => category.id === action.payload.id && category.value === action.payload.value,
        ) >= 0
      ) {
        return;
      }
      const index = state.primaryCategories?.findIndex((category) => category.id === action.payload.id);

      if (index >= 0) {
        state.primaryCategories.splice(index, 1);

        state.secondaryCategories.forEach((category, idx) => {
          if (category.id === action.payload.id) {
            state.secondaryCategories.splice(idx, 1);
          }
        });
        state.thirdLevelCategories.forEach((category, idx) => {
          if (category.id === action.payload.id) {
            state.thirdLevelCategories.splice(idx, 1);
          }
        });
      }

      state.primaryCategories = [...state.primaryCategories];
      state.secondaryCategories = [...state.secondaryCategories];
      state.thirdLevelCategories = [...state.thirdLevelCategories];
    },
    addPrimaryCategory: (state, action) => {
      if (
        state.primaryCategories?.findIndex(
          (category) => category.id === action.payload.id && category.value === action.payload.value,
        ) >= 0
      ) {
        return;
      }
      const index = state.primaryCategories?.findIndex((category) => category.id === action.payload.id);

      if (index >= 0) {
        state.primaryCategories.splice(index, 1);

        state.secondaryCategories.forEach((category) => {
          if (category.id === action.payload.id) {
            category.value = -1;
          }
        });
        state.thirdLevelCategories.forEach((category) => {
          if (category.id === action.payload.id) {
            category.value = -1;
          }
        });
      }

      state.primaryCategories = [action.payload, ...state.primaryCategories];
    },
    addSecondaryCategory: (state, action) => {
      if (
        state.secondaryCategories?.findIndex(
          (category) => category.id === action.payload.id && category.value === action.payload.value,
        ) >= 0
      ) {
        return;
      }
      const index = state.secondaryCategories?.findIndex((category) => category.id === action.payload.id);

      if (index >= 0) {
        state.secondaryCategories.splice(index, 1);

        state.thirdLevelCategories.forEach((category) => {
          if (category.id === action.payload.id) {
            category.value = -1;
          }
        });
      }
      state.secondaryCategories = [action.payload, ...state.secondaryCategories];
    },
    addThirdLevelCategory: (state, action) => {
      if (
        state.thirdLevelCategories?.findIndex(
          (category) => category.id === action.payload.id && category.value === action.payload.value,
        ) >= 0
      ) {
        return;
      }
      const index = state.thirdLevelCategories?.findIndex((category) => category.id === action.payload.id);

      if (index >= 0) {
        state.thirdLevelCategories.splice(index, 1);
      }
      state.thirdLevelCategories = [action.payload, ...state.thirdLevelCategories];
    },
    setIsOpened: (state, action) => {
      state.isOpened = action.payload;
    },
    removePrimaryCategories: (state) => {
      state.primaryCategories = [];
    },
    removeSecondaryCategories: (state) => {
      state.secondaryCategories = [];
    },
    removeThirdLevelCategories: (state) => {
      state.thirdLevelCategories = [];
    },
    setSelectedPrimaryCategory: (state, action) => {
      state.selectedPrimaryCategory = action.payload;
    },
    setSelectedSecondaryCategory: (state, action) => {
      state.selectedSecondaryCategory = action.payload;
    },
    setSelectedThirdLevelCategory: (state, action) => {
      state.selectedThirdLevelCategory = action.payload;
    },
    setSuggestedCategoriesById: (state, { payload: suggestedCategoriesToIdPairs }) => {
      suggestedCategoriesToIdPairs
        .filter(({ suggestedCategory }) => suggestedCategory.id !== 0)
        .forEach(({ srID, suggestedCategory }) => {
          state.suggestedCategoriesBySrId[srID] = suggestedCategory;
        });
    },
    clearSuggestedCategoriesById: (state) => {
      state.suggestedCategoriesBySrId = {};
    },
    setSuggestedCategorySelected: (state, { payload }) => {
      const { srId, isSelected } = payload;

      const suggestedCategory = state.suggestedCategoriesBySrId[srId];

      if (suggestedCategory) {
        suggestedCategory.isSelected = isSelected;
      }
    },
  },
});

export const {
  addPrimaryCategory,
  addSecondaryCategory,
  addThirdLevelCategory,
  setIsOpened,
  removePrimaryCategories,
  removeSecondaryCategories,
  removePrimaryCategory,
  removeThirdLevelCategories,
  setSelectedPrimaryCategory,
  setSelectedSecondaryCategory,
  setSelectedThirdLevelCategory,
  setSuggestedCategoriesById,
  clearSuggestedCategoriesById,
  setSuggestedCategorySelected,
} = categorySlice.actions;

export const selectPrimaryCategory = (id) => (allSliceState) =>
  allSliceState?.category?.primaryCategories?.find((category) => category.id === id);

export const selectSecondaryCategory = (id) => (allSliceState) =>
  allSliceState?.category?.secondaryCategories?.find((category) => category.id === id);

export const selectThirdLevelCategory = (id) => (allSliceState) =>
  allSliceState?.category?.thirdLevelCategories?.find((category) => category.id === id);

export const selectIsOpened = () => (allSliceState) => allSliceState?.category?.isOpened;

export const selectSelectedPrimaryCategory = () => (allSliceState) => allSliceState?.category?.selectedPrimaryCategory;
export const selectSelectedSecondaryCategory = () => (allSliceState) =>
  allSliceState?.category?.selectedSecondaryCategory;
export const selectSelectedThirdLevelCategory = () => (allSliceState) =>
  allSliceState?.category?.selectedThirdLevelCategory;

export const selectSuggestedCategoryById = (srId) => (allSlicesState) =>
  allSlicesState.category.suggestedCategoriesBySrId[srId];

export default categorySlice.reducer;
export const categorySliceName = categorySlice.name;
